import { createSlice } from '@reduxjs/toolkit'

import { fetchTransactionHistory } from './actions/fetch_transaction_history'

const transactionHistorySlice = createSlice({
  name: 'transactionHistory',
  initialState: {
    charges: [],
    invoices: [],
    refunds: undefined,
    error: null,
    initialized: false
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTransactionHistory.pending, (state) => {
      state.initialized = false
      state.error = null
    })
    builder.addCase(fetchTransactionHistory.fulfilled, (state, action) => {
      state.initialized = true
      state.error = null
      state.charges = action.payload.charges || []
      state.invoices = action.payload.invoices || []
      state.refunds = action.payload.refunds
    })
    builder.addCase(fetchTransactionHistory.rejected, (state, action) => {
      state.initialized = true
      state.error = action.payload
    })
  }
})

export const { reducer } = transactionHistorySlice
